import React, { useEffect } from 'react';
import AppView from '@common/components/app-view/app-view';
import CreditsUsageComponent from '@common/components/credits-usage/credits-usage';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';
import { AccountPage } from '@/common/components/account-page/account-page';
import { useAnalyticsService } from '@common-reducers/hooks/use-analytics-service';
import classes from "../account-view/account-view.module.scss";

const CreditsUsageView = () => {
  const { t } = useTranslation(namespace);
  const analyticsService = useAnalyticsService();

  useEffect(() => {
    // Track view_item event for credits usage page visit
    analyticsService.ecommerceEvent('view_item', {
      currency: 'USD',
      items: [{
        item_id: 'credits_usage_page',
        item_name: 'Credits & Usage',
        item_category: 'account_management',
        item_brand: 'Blueticks',
        quantity: 1
      }]
    }, {
      page_title: t('credits.title', 'Credits & Usage'),
      page_location: window.location.href
    });
  }, [t, analyticsService]);

  // Create the page content with the title
  const pageContent = (
    <div className={classes.pageContainer}>
      <div className={classes.titleContainer}>
        <h4 className={classes.pageTitle}>{t('credits.title', 'Credits & Usage')}</h4>
      </div>
      <div className={classes.accountSettingBody}>
        <CreditsUsageComponent />
      </div>
    </div>
  );

  return (
    <AccountPage page={pageContent} />
  );
};

export default CreditsUsageView; 